import { Icon, TextPassage } from '@petsmart-ui/sparky';

import { decodeEntityString } from '@libs/algolia';
import { formatAutoshipFrequency } from '@libs/common-next';

import { ResponsivePicture } from '../ResponsivePicture';
import type { DrawerItem } from './model/useCartConfirmDrawer';

export const CartItem = ({ name, image, autoshipFrequency, autoshipFrequencyUnitOfMeasure }: DrawerItem) => {
    const frequencyText = formatAutoshipFrequency(autoshipFrequency, autoshipFrequencyUnitOfMeasure);

    return (
        <li className="basket-item">
            <div className="basket-item__image-container">
                {autoshipFrequency && (
                    <Icon
                        name="autoship-fill"
                        className="basket-item__recurring-icon"
                        size="md"
                        data-testid="recurring-icon"
                    />
                )}
                <ResponsivePicture src={image ?? ''} alt={`${name} image`} size={{ width: 80, height: 80 }} />
            </div>
            <div className="basket-item__content">
                {autoshipFrequency && (
                    <TextPassage size="sm" className="basket-item__autoship-frequency" data-testid="autoship-frequency">
                        Ships every {frequencyText}
                    </TextPassage>
                )}
                <TextPassage>{decodeEntityString(name)}</TextPassage>
            </div>
        </li>
    );
};
